import { Component } from '@angular/core';

@Component({
    selector: 'app-prepare-subject-list-home',
    templateUrl: './prepare-subject-list-home.component.html',
    styleUrls: ['./prepare-subject-list-home.component.scss']
})
export class PrepareSubjectListHomeComponent {
    constructor() {}
}
